import { render, staticRenderFns } from "./AreaEmbargadaIcmbio.vue?vue&type=template&id=7c43559b&lang=pug"
import script from "./AreaEmbargadaIcmbio.vue?vue&type=script&lang=js"
export * from "./AreaEmbargadaIcmbio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports